<template>
    <div ref="consumerInsightPieChart" style="width: 100%; height: 300px;"></div>
</template>

<script>
    /* Imports */
    import qs from 'qs'
    import moment from 'moment'
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    export default {
        data () {

            let startDate = moment().startOf('month').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                chart : null,
                label : null,
                colors: ['#80B2F0', '#80F2AC', '#F2BC80', '#F2809F', '#ACF9FF'],
                filter: {
                    startDate,
                    endDate: currentDate
                },
                dummyData : [
                    {variant:"Muffler Protector", value:21000},
                    {variant:"Spion", value:19000},
                    {variant:"Helm", value:17000},
                    {variant:"Hand Grip", value:25000},
                ]
            }
        },
        props : ['data', 'filter'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'filter' : {
                deep : true,
                handler : 'getData',
            },
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {

                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                
                this.$http.get(`/api/home/defect-by-part?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp) => {
                    let length = this.chart.data.length;
                    let total = 0
                    let topCount = 0
                    let topLabel = ""
                    let data = resp.data.data && resp.data.data.length > 0 ? resp.data.data.map((x, i)=>{
                        total += parseInt(x.jumlah_rusak)
                        if (x.jumlah_rusak > topCount) {
                            topCount = x.jumlah_rusak
                            topLabel = x.partname
                        }
                        return {
                        partname : x.partname,
                        jumlah_rusak : x.jumlah_rusak,
                        color : this.colors[i%this.colors.length],
                    }}) : [{
                        partname: 'No Data',
                        jumlah_rusak: 1,
                        color: '#83A2FF'
                    }];
                    let topPercentage = topCount > 0 ? ((topCount / total) * 100).toFixed(1) : 0;
                    this.label.html =  `<div style="font-size: 18px; font-weight: bold">${topPercentage}%</div>
                    <div style="font-size: 14px; font-weight: 400;">${topLabel}</div>`;

                    this.chart.addData(data, length);
                })
                // let length = this.chart.data.length;
                // if (this.data && this.data.length > 0) {
                //     let total = 0;
                //     for (var i in this.data) total += this.data[i].value;
                //     this.label.text = `Total\n${this.numberWithCommas(total)}`;
                // } else {
                //     this.label.text = "Total\n0";
                // }
                // this.chart.addData(this.data && this.data.length > 0 ? this.data : [{variant : 'No Data', value : 1}], length);
                // let length = this.chart.data.length;
                // if (this.dummyData && this.dummyData.length > 0) {
                //     let total = 0;
                //     for (var i in this.dummyData) total += this.dummyData[i].value;
                //     this.label.text = `Total\n${this.numberWithCommas(total)}`;
                // } else {
                //     this.label.text = "Total\n0";
                // }
                // this.chart.addData(this.dummyData && this.dummyData.length > 0 ? this.dummyData : [{variant : 'No Data', value : 1}], length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.consumerInsightPieChart, am4charts.PieChart);

                this.chart.colors.list = [
                    am4core.color("#80B2F0"),
                    am4core.color("#80F2AC"),
                    am4core.color("#F2BC80"),
                    am4core.color("#F2809F"),
                    am4core.color('#ACF9FF')
                ]

                // Add and configure Series
                let pieSeries = this.chart.series.push(new am4charts.PieSeries());
                pieSeries.dataFields.value = "jumlah_rusak";
                pieSeries.dataFields.category = "partname";

                // Let's cut a hole in our Pie chart the size of 55% the radius
                this.chart.innerRadius = am4core.percent(50);

                // Put a thick white border around each Slice
                pieSeries.slices.template.stroke = am4core.color("#fff");
                pieSeries.slices.template.strokeWidth = 2;
                pieSeries.slices.template.strokeOpacity = 1;
                pieSeries.slices.template
                // change the cursor on hover to make it apparent the object can be interacted with
                .cursorOverStyle = [
                    {
                    "property": "cursor",
                    "value": "pointer"
                    }
                ];


                pieSeries.slices.template.adapter.add("fill", (fill, target)=>{
                    return this.chart.colors.getIndex(target.dataItem.index);
                })

                pieSeries.alignLabels = false;
                // pieSeries.labels.template.bent = true;
                // pieSeries.labels.template.radius = 3;
                // pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.ticks.template.disabled = true;
                pieSeries.alignLabels = false;
                pieSeries.labels.template.text = ""; // "[bold]{value.percent.formatNumber('#.0')}%";
                pieSeries.labels.template.bent = true;
                pieSeries.labels.template.radius = am4core.percent(-25);
                pieSeries.labels.template.fill = am4core.color("#FFF");
                pieSeries.labels.template.padding(0,0,0,0);

                pieSeries.labels.template.adapter.add("radius", (radius, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.percent(2.5);
                    } 
                    return radius;
                })

                pieSeries.labels.template.adapter.add("fill", (color, target) => {
                    if (target.dataItem && (target.dataItem.values.value.percent < 8)) {
                        return am4core.color("#000");
                    } 
                    return color;
                })

                // Create a base filter effect (as if it's not there) for the hover to return to
                let shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
                shadow.opacity = 0;

                // Create hover state
                let hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

                // Slightly shift the shadow and make it more prominent on hover
                let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter);
                hoverShadow.opacity = 0.7;
                hoverShadow.blur = 5;

                // Add a legend
                this.chart.legend = new am4charts.Legend();
                this.chart.legend.useDefaultMarker = true;
                this.chart.legend.maxHeight = 100;
                this.chart.legend.scrollable = true;
                var marker = this.chart.legend.markers.template;
                // marker.cornerRadius(12, 12, 12, 12);
                marker.width = 5;
                marker.height = 20;


                // Add label
                // this.chart.innerRadius = 100;
                this.label = this.chart.seriesContainer.createChild(am4core.Label);
                this.label.text = "Total\n0";
                this.label.horizontalCenter = "middle";
                this.label.verticalCenter = "middle";
                this.label.textAlign = "middle";
                this.label.fontSize = 20;

                // let label2 = this.chart.seriesContainer.createChild(am4core.label);
                // label.text = "2000";
                // label.horizontalCenter = "middle";
                // label.verticalCenter = "bottom";
                // label.fontSize = 30;
            }   
        }
    }
</script>

<style scoped>

</style>